/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/itp-export/QaItpRecipientsField.tsx
 * FILE_ID: JOBHUB-QA-ITP-RECIPIENTS-001
 * PURPOSE: Many To, CC or BCC addresses, stored as one comma string.
 */
// Reused from Emails Hub: RecipientAutocomplete.tsx (chips, comma/;/Enter/Tab/blur commit, paste split, X and Backspace remove, contact suggestions)
import RecipientAutocomplete from '@quotech/email-hub/feature/components/RecipientAutocomplete'
import { splitRecipients } from './itpRecipients'

export function QaItpRecipientsField({
  label,
  value,
  onChange,
  placeholder,
}: {
  label: string
  value: string
  onChange: (next: string) => void
  placeholder?: string
}) {
  const list = splitRecipients(value)
  return (
    <div className="block text-sm">
      <span className="mb-1 block">{label}</span>
      <div
        className="rounded-lg border border-border bg-background px-1 [&_.border-b]:border-b-0"
        onKeyDownCapture={(event) => {
          const input = event.target as HTMLInputElement
          if (event.key === 'Delete' && input.tagName === 'INPUT' && input.value === '' && list.length > 0) {
            event.preventDefault()
            onChange(list.slice(0, -1).join(', '))
          }
        }}
      >
        <RecipientAutocomplete
          value={list}
          onChange={(next) => onChange(next.join(', '))}
          placeholder={placeholder}
          ariaLabel={label}
        />
      </div>
    </div>
  )
}
